export function initHotspots() {
    const wrapper = document.querySelector('.js-hotspot-wrapper');
    if (wrapper) {
        console.log('[Main] Hotspot Wrapper found! Loading logic chunk...');

        // 2. IMPORT DINAMICO
        import('./hotspots.js')
            .then(module => {
                console.log('[Main] Logic loaded successfully. Executing default()...');
                module.default();
            })
            .catch(err => {
                console.error('[Main] Error loading hotspots.js:', err);
            });
    }
}
